import { render } from "./CCPartner.vue?vue&type=template&id=5f839e61&scoped=true&ts=true"
import script from "./CCPartner.vue?vue&type=script&lang=ts"
export * from "./CCPartner.vue?vue&type=script&lang=ts"

import "./CCPartner.vue?vue&type=style&index=0&id=5f839e61&scoped=true&lang=less"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f839e61"]])

export default __exports__